import { render, staticRenderFns } from "./cLanding.vue?vue&type=template&id=fba760d4&scoped=true"
import script from "./cLanding.vue?vue&type=script&lang=js"
export * from "./cLanding.vue?vue&type=script&lang=js"
import style0 from "./cLanding.vue?vue&type=style&index=0&id=fba760d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba760d4",
  null
  
)

export default component.exports